import React, {Component} from 'react';
// import Slider from 'react-slick';
// import Modal from 'react-responsive-modal'
import { connect } from 'react-redux';
import {isEqual, find, clone} from 'lodash'
// import Product from '../../templates/product';
import getSymbolFromCurrency from 'currency-symbol-map'
// import SheerStraightKurta from './SheerStraightKurta';
import { addToCart } from '../../actions/cart';

class DetailsWithPrice extends Component {

    constructor (props) {
        super (props)
        const {product} = this.props
        this.state = {
            open:false,
            quantity:1,
            availableForSale: product.variants[0] !== null && product.variants[0].availableForSale,
            nav3: null,
            currentOptions: product.variants[0] !== null ? product.variants[0].selectedOptions : [],
            variantId: product.variants[0] !== null ? product.variants[0].shopifyId: null,
            price: product.variants[0] !== null ? this.getPrice(product.variants[0]):'',
            oldPrice: product.variants[0].compareAtPriceV2 !== null ? this.getOldPrice(product.variants[0]): null ,
            checkoutId: this.props.storefront.checkout !== null ? this.props.storefront.checkout.id : '',
        }
        
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.storefront.success !== this.props.storefront.success && nextProps.storefront.success === true) {     
            const {checkout} = nextProps.storefront
            this.setState({ 
                checkoutId: checkout.id
            })
        }
    }

    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    componentDidMount() {
        // this.setState({
        //     nav3: this.slider3
        // });
    }

    minusQty = () => {
        if(this.state.quantity > 1) {
            // this.setState({stock: 'InStock'})
            this.setState({quantity: this.state.quantity - 1})
        }
    }

    plusQty = () => {
        // if(this.props.item.stock >= this.state.quantity) {
            this.setState({quantity: this.state.quantity+1})
        // }else{
        //     this.setState({stock: 'Out of Stock !'})
        // }
    }
    changeQty = (e) => {
        this.setState({ quantity: parseInt(e.target.value) })
    }

    getPrice = (variant) => {
        return getSymbolFromCurrency(variant.priceV2.currencyCode)+''+(Number.parseFloat(variant.priceV2.amount).toFixed(2))
    }

    getOldPrice = (variant) => {
        return getSymbolFromCurrency(variant.priceV2.currencyCode)+''+(Number.parseFloat(variant.compareAtPriceV2.amount).toFixed(2))
    }

    handleOptionsChange = (optionIndex, {target}) => {
        const {value} = target

        const newOptions = clone(this.state.currentOptions, true)

        newOptions[optionIndex] = {
            ...newOptions[optionIndex],
            value
        }

        const selectedVariant = find(this.props.product.variants, ({ selectedOptions }) =>
            isEqual(selectedOptions,newOptions)
        )

        this.setState({
            currentOptions: newOptions,
            variantId: selectedVariant.shopifyId,
            price: this.getPrice(selectedVariant),
            oldPrice: this.getOldPrice(selectedVariant),
            availableForSale: selectedVariant.availableForSale
        })

    }

    render (){
        // const {symbol, item, addToCartClicked, BuynowClicked, addToWishlistClicked} = this.props
        
        // var colorsnav = {
        //     slidesToShow: 6,
        //     swipeToSlide:true,
        //     arrows: false,
        //     dots: false,
        //     focusOnSelect: true
        // };

        const product = this.props.product

    
        return (
            <div className="col-lg-6 rtl-text">
                 <div className="product-right">
                    <h2> {product.title} </h2>
                    {(!this.props.fetchingReviews && this.props.reviewsData !== null && this.props.reviewsData[1] !== null && this.props.reviewsData[1].result !== null) && <div className="yotpo bottomLine mb-4" dangerouslySetInnerHTML={{__html: this.props.reviewsData[1].result}}></div>}
                    {(this.state.oldPrice !== null && this.state.oldPrice>this.state.price) && (
                        <h4>
                            <del>{this.state.oldPrice}</del>
                            {/* <span>{item.discount}% off</span> */}
                        </h4>
                    )}
                    <h3>{this.state.price}</h3>
                    {/* {item.variants?
                    <ul >
                        <Slider {...colorsnav} asNavFor={this.props.navOne} ref={slider => (this.slider1 = slider)} className="color-variant">
                            {item.variants.map((vari, i) => {
                                return <li className={vari.color} key={i} title={vari.color}></li>
                            })}
                        </Slider>
                    </ul>:''} */}
                   <div className="product-description border-product">
                        {/* {item.size? */}
                            {/* <div> */}
                                {/* <h6 className="product-title size-text">select size
                                    <span><a href="#" data-toggle="modal"
                                             data-target="#sizemodal" onClick={this.onOpenModal} >size chart</a></span></h6> */}

                                {/* <div className="modal fade" id="sizemodal" tabIndex="-1"
                                     role="dialog" aria-labelledby="exampleModalLabel"
                                     aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered"
                                         role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title"
                                                    id="exampleModalLabel">Sheer Straight
                                                    Kurta</h5>
                                                <button type="button" className="close"
                                                        data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <SheerStraightKurta />
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="size-box">
                                    <ul>
                                        {item.size.map((size, i) => {
                                            return <li key={i}><a href="#">{size}</a></li>
                                        })}
                                    </ul>
                                </div> */}
                                {/* </div> */}
                            {/* </div>:''} */}
                        

                        {product.options.map((option,key) => (
                            option.name !== 'Title' && <div key={key} className="pb-3">
                                <h6 className="product-title">{option.name}</h6>
                                <select className="form-control" onChange={(event) => this.handleOptionsChange(key,event)}>
                                    {option.values.map((value,key) => (
                                        <option key={key}>{value}</option>
                                    ))}
                                </select>
                            </div>
                        ))}

                        <h6 className="product-title">quantity</h6>
                        <span className="instock-cls">{this.state.availableForSale ? 'InStock':'Out of Stock !'}</span>
                        
                        {this.state.availableForSale && (
                            <>
                                <h6 className="product-title pt-3">quantity</h6>
                                <div className="qty-box">
                                    <div className="input-group">
                                        <span className="input-group-prepend">
                                            <button type="button" className="btn quantity-left-minus" onClick={this.minusQty} data-type="minus" data-field="">
                                            <i className="fa fa-angle-left"></i>
                                            </button>
                                        </span>
                                        <input type="text" name="quantity" value={this.state.quantity} onChange={this.changeQty} className="form-control input-number" />
                                        <span className="input-group-prepend">
                                        <button type="button" className="btn quantity-right-plus" onClick={this.plusQty} data-type="plus" data-field="">
                                        <i className="fa fa-angle-right"></i>
                                        </button>
                                    </span>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="product-buttons" >
                        <button className="btn btn-solid" disabled={!this.state.availableForSale} onClick={() => this.props.addToCart(
                            this.state.checkoutId, [{
                                variantId: this.state.variantId,
                                quantity: this.state.quantity
                            }]
                        )}>add to cart</button >
                        {/* checkout // onClick={() => BuynowClicked(item, this.state.quantity)} */}
                        {/* <Link to={`/`} className="btn btn-solid">buy now</Link> */}
                    </div>
                    <div className="border-product">
                        <h6 className="product-title mb-5">product details</h6>
                        <p dangerouslySetInnerHTML={{__html: product.descriptionHtml}}></p>
                    </div>
                    {/* <div className="border-product">
                        <h6 className="product-title">share it</h6>
                        <div className="product-icon">
                            <ul className="product-social">
                                <li><a href="https://www.facebook.com/" target="_blank"><i className="fa fa-facebook"></i></a></li>
                                <li><a href="https://plus.google.com/discover" target="_blank"><i className="fa fa-google-plus"></i></a></li>
                                <li><a href="https://twitter.com/" target="_blank"><i className="fa fa-twitter"></i></a></li>
                                <li><a href="https://www.instagram.com/" target="_blank"><i className="fa fa-instagram"></i></a></li>
                            </ul>
                            <button className="wishlist-btn" onClick={() => addToWishlistClicked(item)}><i
                                className="fa fa-heart"></i><span
                                className="title-font">Add To WishList</span>
                            </button>
                        </div>
                    </div> */}
                    {/* <div className="border-product">
                        <h6 className="product-title">Time Reminder</h6>
                        <div className="timer">
                            <p id="demo">
                                <span>25
                                    <span className="padding-l">:</span>
                                    <span className="timer-cal">Days</span>
                                </span>
                                <span>22
                                    <span className="padding-l">:</span>
                                    <span className="timer-cal">Hrs</span>
                                </span>
                                <span>13
                                    <span className="padding-l">:</span>
                                    <span className="timer-cal">Min</span>
                                </span>
                                <span>57
                                    <span className="timer-cal">Sec</span>
                                </span>
                            </p>
                        </div>
                    </div> */}
                </div>
                {/* <Modal open={this.state.open} onClose={this.onCloseModal} center>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Sheer Straight Kurta</h5>
                            </div>
                            <div className="modal-body">
                                <SheerStraightKurta />
                            </div>
                        </div>
                    </div>
                </Modal> */}
            </div>
        )
    }
}

const mapStateToProps = ({cartReducer}) => {
    return {
        storefront: cartReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (checkoutId, lineItems) => dispatch(addToCart(checkoutId, lineItems))
    }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(DetailsWithPrice);